export default function GlobalReach() {
  const regions = [
    { name: "Middle East", countries: "UAE · KSA · Oman · Qatar · Bahrain" },
    { name: "Europe", countries: "Germany · Netherlands · UK · Spain · Italy" },
    { name: "South-East Asia", countries: "Vietnam · Malaysia · Indonesia · Singapore" },
    { name: "Africa", countries: "Kenya · Egypt · Nigeria · South Africa" },
    { name: "Americas", countries: "USA · Canada · Brazil · Mexico" },
    { name: "East Asia", countries: "China · Japan · South Korea" },
  ];

  return (
    <section id="reach" data-testid="global-reach-section" className="relative py-24 md:py-32 bg-[#1A3626] overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1712150177656-b3c0bd50eb25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMG1hcCUyMGFic3RyYWN0JTIwZ29sZHxlbnwwfHx8fDE3ODI3NzY0MjB8MA&ixlib=rb-4.1.0&q=85"
        alt="Abstract world map"
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A3626]/80 to-[#1A3626]/40"></div>
      <div className="absolute inset-0 grain"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 reveal">
            <p className="overline text-[#E6C97A]">Reach</p>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight">
              Shipping to<br />
              <span className="text-[#E6C97A] italic">five continents.</span>
            </h2>
            <p className="mt-6 text-white/75 text-lg leading-relaxed max-w-md">
              Documentation, compliance and logistics — handled locally in the languages
              and standards your market expects.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-lg">
              {[
                { k: "40+", v: "Countries" },
                { k: "12", v: "Origin ports" },
                { k: "24/7", v: "Trade desk" },
              ].map((s) => (
                <div key={s.v} className="border-t border-[#C5A059]/40 pt-4">
                  <div className="font-serif-display text-white text-3xl md:text-4xl">
                    {s.k}
                  </div>
                  <div className="text-xs tracking-widest uppercase text-white/60 mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 reveal">
            {regions.map((r, idx) => (
              <div
                key={r.name}
                className="border border-white/15 hover:border-[#C5A059] transition-colors duration-300 p-6"
              >
                <div className="flex items-center justify-between">
                  <p className="overline text-white/50">0{idx + 1}</p>
                  <span className="text-[#C5A059] text-xs">Active</span>
                </div>
                <h3 className="mt-3 font-serif-display text-2xl text-white leading-tight">
                  {r.name}
                </h3>
                <p className="mt-2 text-white/65 text-sm">{r.countries}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
